import * as types from "../actions/ActionTypes";

const defaultState = {
  paymentContentPosting: false,
  paymentContentPosted: false,
  paymentContentError: {},
  paymentBoostPosting: false,
  paymentBoostPosted: false,
  paymentBoostError: false,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.PAYMENT_CONTENT_POST_PENDING:
      return Object.assign({}, state, {
        paymentContentPosting: true,
      });
    case types.PAYMENT_CONTENT_POST_FULFILLED:
      return Object.assign({}, state, {
        paymentContentPosting: false,
        paymentContentPosted: true,
      });
    case types.PAYMENT_CONTENT_POST_REJECTED:
      return Object.assign({}, state, {
        paymentContentPosting: false,
        paymentContentError: action.payload.response,
      });
    case types.PAYMENT_CONTENT_BOOST_PENDING:
      return Object.assign({}, state, {
        paymentBoostPosting: true,
      });
    case types.PAYMENT_CONTENT_BOOST_FULFILLED:
      return Object.assign({}, state, {
        paymentBoostPosting: false,
        paymentBoostPosted: true,
      });
    case types.PAYMENT_CONTENT_BOOST_REJECTED:
      return Object.assign({}, state, {
        paymentBoostPosting: false,
        paymentBoostError: true,
      });
    case types.PAYMENT_APPLY_TICKET_REJECTED:
      return state;
    case types.CLEAR_PAYMENT_BOOST_ERROR:
      return Object.assign({}, state, {
        paymentBoostError: false,
      });

    case "LOGOUT":
      return defaultState;

    default:
      return state;
  }
}
